module.exports = __webpack_public_path__ + "img/26.9e75cd2e.jpg";